import { Navigate, Route, Routes } from 'react-router-dom';
import Layout from './components/Layout';
import ViviendasView from './views/ViviendasView';
import ClientesView from './views/ClientesView';
import IncidenciasView from './views/IncidenciasView';
import OperacionesView from './views/OperacionesView';
import AgendaView from './views/AgendaView';
import ComisionesView from './views/ComisionesView';
import ContabilidadView from './views/ContabilidadView';
import AjustesView from './views/AjustesView';
import CostesView from './views/CostesView';
import ServiciosView from './views/ServiciosView';
import CuentasView from './views/CuentasView';
import TuWebView from './views/TuWebView';
import { useMe } from './api/me';

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Navigate to="/viviendas" replace />} />
        <Route path="/viviendas" element={<ViviendasView />} />
        <Route path="/clientes" element={<ClientesView />} />
        <Route path="/incidencias" element={<IncidenciasView />} />
        <Route path="/operaciones" element={<OperacionesView />} />
        <Route path="/agenda" element={<AgendaView />} />
        <Route path="/comisiones" element={<ComisionesView />} />
        <Route path="/contabilidad" element={<ContabilidadView />} />
        <Route path="/costes" element={<SoloAdmin><CostesView /></SoloAdmin>} />
        <Route path="/servicios" element={<SoloAdmin><ServiciosView /></SoloAdmin>} />
        <Route path="/cuentas" element={<SoloAdmin><CuentasView /></SoloAdmin>} />
        <Route path="/tu-web" element={<SoloAdmin><TuWebView /></SoloAdmin>} />
        <Route path="/ajustes" element={<AjustesView />} />
        <Route path="*" element={<Navigate to="/viviendas" replace />} />
      </Route>
    </Routes>
  );
}

/** Costes es solo para el admin. Un agente que llegue por URL vuelve a
 *  Viviendas; el backend además le contesta 403. */
function SoloAdmin({ children }: { children: JSX.Element }) {
  const { data: me, isLoading } = useMe();
  if (isLoading) return null;
  return me?.groups.includes('admin') ? children : <Navigate to="/viviendas" replace />;
}
